import { Target, ShieldCheck } from "lucide-react";
import useReveal from "@/hooks/useReveal";

const PROOFS = [
  {
    id: "tailored",
    icon: Target,
    title: "Tailored for Oil & Gas",
    desc: "Not a generic accounting app forced to fit the patch. Built specifically for complex multi-partner energy assets.",
    accent: "Built for the patch",
  },
  {
    id: "security",
    icon: ShieldCheck,
    title: "Enterprise-Grade Security",
    desc: "Your ownership and financial data are secured with continuous monitoring and heavy encryption.",
    accent: "Encrypted end-to-end",
  },
];

export default function ProofSection() {
  const headerRef = useReveal();

  return (
    <section
      id="proof"
      data-testid="proof-section"
      className="relative bg-[#F4F3EE] py-24 md:py-32 border-t border-[#D3D9DE]"
    >
      <div className="gp-container">
        <div ref={headerRef} className="reveal max-w-3xl mb-16 md:mb-20">
          <span className="gp-overline">// The proof point</span>
          <h2
            data-testid="proof-heading"
            className="mt-6 font-display text-4xl sm:text-5xl lg:text-6xl font-semibold tracking-tight text-[#111418] leading-[1.05]"
          >
            Built for the field,{" "}
            <span className="italic text-[#0F4C5C]">trusted for the books.</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-10">
          {PROOFS.map((proof, i) => {
            const Icon = proof.icon;
            return (
              <ProofCard key={proof.id} proof={proof} icon={Icon} index={i} />
            );
          })}
        </div>
      </div>
    </section>
  );
}

function ProofCard({ proof, icon: Icon, index }) {
  const ref = useReveal();
  return (
    <article
      ref={ref}
      data-testid={`proof-card-${proof.id}`}
      style={{ transitionDelay: `${index * 100}ms` }}
      className="reveal relative bg-white border border-[#D3D9DE] p-8 lg:p-12 transition-all duration-300 hover:-translate-y-1 hover:border-[#D67229] hover:shadow-[12px_12px_0_0_#082933]"
    >
      <div className="flex items-start justify-between mb-8">
        <div className="h-14 w-14 border border-[#111418] flex items-center justify-center text-[#0F4C5C]">
          <Icon size={24} strokeWidth={1.6} />
        </div>
        <span className="font-mono text-[10px] uppercase tracking-[0.22em] text-[#D67229]">
          // {proof.accent}
        </span>
      </div>
      <h3 className="font-display text-3xl md:text-4xl text-[#111418] leading-tight">
        {proof.title}
      </h3>
      <p className="mt-5 text-lg text-[#2C333A] leading-relaxed max-w-md">
        {proof.desc}
      </p>
    </article>
  );
}
